export default "__VITE_ASSET__sp7syk5l__"